export default __webpack_public_path__ + "static/CentraNo2-Book-09611d5dd4f6f5413ae28e1968e02196.woff2";